import { TypeBoxFields } from 'contentful-types'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import Box from './Box'

const ContentfulBox = withContentful<TypeBoxFields>(Box, {
  children: (props) => <BlockRenderer block={props.fields.blocks} fieldPath={'.blocks'} />,
})

export default ContentfulBox
